import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/gfx-about.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "970",
  height: "252"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "main-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "About Moksha"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("table", {
    width: "100%",
    border: "0",
    cellspacing: "0",
    cellpadding: "11"
  }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { bgcolor: "#069" }, [
        /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#FFF"} }, [
          /*#__PURE__*/_createTextVNode("The word "),
          /*#__PURE__*/_createElementVNode("em", null, "\"moksha\""),
          /*#__PURE__*/_createTextVNode(" is an ancient Sanskrit one which means: the ultimate state of absolute freedom; liberation from ignorance and suffering; and, essentially, Freedom.")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("The company was established in 2002 and has become a well-known South African brand, receiving coverage in leading national publications. The business had its genesis as a wellness business encompassing a yoga studio, clothing line, retreats, international teaching, teacher training and workshops. Yoga contains in practice a model for operation of the sustainable corporations of the future. Those companies that are agile and adaptable, yet focused and disciplined, will have a competitive advantage over others. This concept of “Leadership Yoga” has been advocated by "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.hbs.edu/faculty/Pages/profile.aspx?facId=6486&view=featured-work",
      target: "_blank"
    }, "Rosabeth Moss Kanter"),
    /*#__PURE__*/_createTextVNode(" who specialises in strategy, innovation, and leadership for change at Harvard Business School.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "The word yoga translates as \"union\", and practising yoga involves alignment of body, mind and spirit. Yoga helps individuals align actions with intention. At a corporate level, Leadership Yoga helps unite core competencies, employee passion and social needs into a single, living and cohesive strategy. The sense of purpose that derives from this alignment is the goal and promise of yoga. "),
  /*#__PURE__*/_createElementVNode("h2", null, "What does Moksha's brand of Leadership Yoga offer then, in short?"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "A turn-key strategic consulting practice."),
    /*#__PURE__*/_createElementVNode("li", null, "A consultancy for revitalisation in distressed situations. "),
    /*#__PURE__*/_createElementVNode("li", null, "A provider of temporary executive capacity."),
    /*#__PURE__*/_createElementVNode("li", null, "A corporate therapist.")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://turnaround.org/business-assistance",
    target: "_blank"
  }, "Corporate Renewal Industry Overview "),
  /*#__PURE__*/_createElementVNode("h2", null, "What else makes Moksha different?"),
  /*#__PURE__*/_createElementVNode("p", null, " Most consulting practices are about moving towards an average, using benchmarking and “best practice” to encourage corporate mediocrity. This results in conformity rather than excellence. Moksha sets companies free by exploring their DNA; by helping find a uniquely sustainable proposition and ensuring consistency when it come to delivery. "),
  /*#__PURE__*/_createElementVNode("p", null, "Moksha offers an authentic and difficult to duplicate market proposition that just feels right."),
  /*#__PURE__*/_createElementVNode("h2", null, "Turnaround Management Association (Southern Africa)"),
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Moksha is a member of the "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://www.tma-sa.com/",
      target: "_blank"
    }, "Turnaround Management Association (Southern Africa)"),
    /*#__PURE__*/_createTextVNode(", a network of professionals specialising in business transformation.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("TMA-SA’s "),
    /*#__PURE__*/_createElementVNode("strong", null, "mission"),
    /*#__PURE__*/_createTextVNode(" is to serve as a forum for professionals from all disciplines engaged in the corporate renewal activities of business transformation, turnaround and business rescue to enable networking, to promote high standards of practice and foster professional development through education as well as through knowledge capture and dissemination.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" TMA-SA’s members represent turnaround and corporate renewal professionals of all disciplines and TMA-SA is an international affiliate of the "),
    /*#__PURE__*/_createElementVNode("a", {
      title: "Turnaround Management Association to which Turnaround Management Association - Southern Africa is affiliated to.",
      href: "http://www.turnaround.org",
      target: "_blank"
    }, "Turnaround Management Association"),
    /*#__PURE__*/_createTextVNode(" (TMA)."),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}